import { createBrowserRouter, Navigate } from "react-router";
import { lazyScreen } from "./lazy";
import { StudioRoot } from "@/features/studio/StudioRoot";
import { ClientLayout } from "@/features/catalog/ClientLayout";
import { HomeScreen } from "@/features/catalog/HomeScreen";
import { ServicesScreen } from "@/features/catalog/ServicesScreen";
import { BookingScreen } from "@/features/my/BookingScreen";
import { MyBookingsScreen } from "@/features/my/MyBookingsScreen";
import { NotFound } from "./NotFound";

// Owner cabinet and assistant load on demand: a customer's phone never downloads them.
const OwnerRoot = lazyScreen(() => import("@/features/owner/OwnerRoot").then((m) => m.OwnerRoot));
const LoginScreen = lazyScreen(() => import("@/features/owner/LoginScreen").then((m) => m.LoginScreen));
const DayScreen = lazyScreen(() => import("@/features/owner/DayScreen").then((m) => m.DayScreen));
const OwnerBookingScreen = lazyScreen(() => import("@/features/owner/OwnerBookingScreen").then((m) => m.OwnerBookingScreen));
const NewBookingScreen = lazyScreen(() => import("@/features/owner/NewBookingScreen").then((m) => m.NewBookingScreen));
const BlockScreen = lazyScreen(() => import("@/features/owner/BlockScreen").then((m) => m.BlockScreen));
const StatsScreen = lazyScreen(() => import("@/features/owner/StatsScreen").then((m) => m.StatsScreen));
const PhotosScreen = lazyScreen(() => import("@/features/owner/PhotosScreen").then((m) => m.PhotosScreen));
const SettingsScreen = lazyScreen(() => import("@/features/owner/SettingsScreen").then((m) => m.SettingsScreen));
const AssistantScreen = lazyScreen(() => import("@/features/assistant/AssistantScreen").then((m) => m.AssistantScreen));

// Route segments must stay in sync with ROUTE_PREFIXES / OWNER_ROUTE_PREFIXES
// (supabase/functions/_shared/routes.ts), which drive the static-host rewrites.
export const router = createBrowserRouter([
  {
    path: "/s/:slug",
    element: <StudioRoot />,
    children: [
      {
        path: "owner",
        element: <OwnerRoot />,
        children: [
          { index: true, element: <Navigate to="day" replace /> },
          { path: "login", element: <LoginScreen /> },
          { path: "day", element: <DayScreen /> },
          { path: "booking/:id", element: <OwnerBookingScreen /> },
          { path: "new", element: <NewBookingScreen /> },
          { path: "block", element: <BlockScreen /> },
          { path: "stats", element: <StatsScreen /> },
          { path: "photos", element: <PhotosScreen /> },
          { path: "settings", element: <SettingsScreen /> },
          { path: "assistant", element: <AssistantScreen scope="owner" /> },
          { path: "*", element: <Navigate to="day" replace /> },
        ],
      },
      {
        element: <ClientLayout />,
        children: [
          { index: true, element: <HomeScreen /> },
          { path: "services", element: <ServicesScreen /> },
          { path: "my", element: <MyBookingsScreen /> },
          { path: "b", element: <BookingScreen /> },
          // Studio info now lives at the bottom of the home page; old links land there.
          { path: "about", element: <Navigate to=".." relative="path" replace /> },
          { path: "assistant", element: <AssistantScreen scope="client" /> },
          { path: "*", element: <NotFound inStudio /> },
        ],
      },
    ],
  },
  { path: "*", element: <NotFound /> },
]);
